import { DEALERSHIP_BUSINESS_TYPES } from 'constants/dealership';

const BUSINESS_TYPES_FOR_RADIO_BUTTONS = [
	{ key: 1, value: DEALERSHIP_BUSINESS_TYPES.independent, label: 'Independent', railsValue: 1 },
	{ key: 2, value: DEALERSHIP_BUSINESS_TYPES.franchise, label: 'Franchise', railsValue: 0 },
	{ key: 3, value: DEALERSHIP_BUSINESS_TYPES.wholesale, label: 'Wholesale', railsValue: 2 },
];

export default BUSINESS_TYPES_FOR_RADIO_BUTTONS;
